'use client';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button, buttonVariants } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useAccountSettings } from '@/hooks/useAccountSettings';
import { useLogout } from '@/hooks/useLogout';
import { errorHandler } from '@/lib/errorHandler';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/store';
import { AlertDialogCancel } from '@radix-ui/react-alert-dialog';
import { Trash } from 'lucide-react';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { toast } from 'sonner';

export const DeleteAccountSettings = () => {
  const [shouldRemoveAllData, setShouldRemoveAllData] = useState(false);
  const { deleteAccountApi } = useAccountSettings();
  const { mutate: logoutApi, isPending: isLoading } = useLogout();
  const clearAuth = useAuthStore((state) => state.clearAuth);

  const router = useRouter();
  const handleDeleteAccount = () => {
    deleteAccountApi.mutate(
      {
        deleteContent: shouldRemoveAllData,
      },
      {
        onSuccess: () => {
          toast.success('Account deleted successfully');
          logoutApi(undefined, {
            onSuccess: () => {
              clearAuth();
              setTimeout(() => {
                router.replace('/sign-in');
              }, 10);
            },
            onError: (error) => {
              toast.error(errorHandler(error));
            },
          });
        },
        onError: (error) => {
          toast.error(errorHandler(error));
        },
      }
    );
  };

  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <h2 className="font-bold text-lg">Delete Account</h2>
        <p className="text-sm">
          Delete your account from the platform permanently
        </p>
      </div>

      <div className="flex justify-end">
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button
              variant="destructive"
              className="font-bold bg-white text-red-500 border hover:bg-red-500/20 hover:border-red-500/20 border-red-500 uppercase"
            >
              <Trash className="w-4 h-4" />
              Delete
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle className="text-base font-bold">
                Delete your account?
              </AlertDialogTitle>
              <AlertDialogDescription>
                Are you sure you want to delete your account?
              </AlertDialogDescription>
            </AlertDialogHeader>
            {/*
            Removed the checkbox as per comments on:
            https://neoito-team-qdvh6v5g.atlassian.net/browse/IHQX-26?focusedCommentId=11188
          */}

            {/* <div className="py-4">
              <div className="flex items-center gap-2">
                <Checkbox
                  id="delete-account"
                  checked={shouldRemoveAllData}
                  onCheckedChange={(checked) =>
                    setShouldRemoveAllData(checked === true)
                  }
                />

                <Label
                  htmlFor="delete-account"
                  className="text-sm text-[#24292E]"
                >
                  Remove all my content from the platform.
                </Label>
              </div>
            </div> */}
            <AlertDialogFooter className="flex justify-between">
              <AlertDialogCancel
                className={cn(
                  buttonVariants({ variant: 'outline', size: 'lg' }),
                  'uppercase font-bold flex-1 w-full text-black hover:bg-black/10 hover:text-black border-black'
                )}
              >
                Cancel
              </AlertDialogCancel>
              <AlertDialogAction
                className={cn(
                  buttonVariants({ variant: 'destructive', size: 'lg' }),
                  'uppercase font-bold flex-1 w-full'
                )}
                onClick={handleDeleteAccount}
              >
                <Trash className="w-4 h-4" />
                Delete
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>
  );
};
